import React from "react";
import { ImgIcon } from "../../assets";
import InfoIcon from "../../assets/InfoIcon";
import { useModal } from "../../assets/useModal";
import TimeBlock from "../../assets/TimeBlock";
import { phone } from "../../assets/icons";

export default function AboutVendor({ vendor }) {

	const { setModal, openModal } = useModal();

	const vendorStyles = {
		backgroundColor: vendor.featureColor1 || "#f8f8f8",
		color: vendor.featureColor2 || "white",
	}

	function showVendorInfo() {
		setModal(<VendorInfo vendor={vendor} />);
		openModal();
	}

	return <div
		className="vendor-about"
		style={vendor.bannerImage ? {
			...vendorStyles,
		} : vendorStyles}
	>
		{vendor.bannerImage && <div className="overlay" style={{
			backgroundImage: `url("${vendor.bannerImage.url}")`,
			backgroundSize: "cover",
			backgroundPosition: "center"
		}} />}
		<div className="inner maximum-width">
			<div className="text-content" onClick={showVendorInfo}>
				{Boolean(vendor.logo) && <ImgIcon
					className="logo"
					cover={true}
					size={100}
					src={vendor.logo.url}
					bg={"#ffffff"}
				/>}
				<div className="text-content-inner">
					<h2>{vendor.name}</h2>
					{Boolean(vendor.description && !vendor.contactTel) && <div className="description">
						{vendor.description}
					</div>}
					{Boolean(vendor.contactTel) && <a 
						href={`tel:${vendor.contactTel}`} 
						className="phone v-middle d-inline-block"
						onClick={e => e.stopPropagation()}
						style={{
							marginTop: 5,
							padding: "5px 0px 5px 0px"
						}}
					>
						<ImgIcon src={phone} size={20} />
						<span style={{ marginLeft: 5 }}>{vendor.contactTel}</span>
					</a>}
				</div>
				<button className="info">
					<InfoIcon
						size={25}
						color={vendorStyles.backgroundColor}
					/>
				</button>
			</div>
		</div>
	</div>
}

function VendorInfo({ vendor }) {

	return <div className="vendorInfo" style={{
		backgroundColor: vendor.featureColor1
	}}>
		{Boolean(vendor.bannerImage) && <div className="bannerImage" style={{
			backgroundImage: `url("${vendor.bannerImage.url}")`
		}} />}
		<div className="vendorInfo-inner">
			<div className="padded">
				<h2>{vendor.name}</h2>
			</div>
			{Boolean(vendor.description) && <div className="padded">
				{vendor.description}
			</div>}
			{Boolean(vendor.contactTel) && <a href={`tel:${vendor.contactTel}`} className="padded phone v-middle d-inline-block">
				<ImgIcon src={phone} size={20} />
				<span style={{ marginLeft: 5 }}>{vendor.contactTel}</span>
			</a>}
			{Boolean(vendor.address) && <>
				<hr />
				<div className="padded">
					<h4>Address</h4>
					<br />
					<div style={{ marginBottom: 4 }}>{vendor.address.line1}</div>
					{Boolean(vendor.address.line2) && <div style={{ marginBottom: 4 }}>{vendor.address.line2}</div>}
					<div style={{ marginBottom: 4 }}>{vendor.address.town}</div>
					<div style={{ marginBottom: 4 }}>{vendor.address.postCode}</div>
				</div>
			</>}
			{Boolean(
				vendor.acceptCollection &&
				vendor.collectionTimes &&
				vendor.collectionTimes.length
			) && <>
					<hr />
					<div className="padded">
						<h4>Opening Hours - Collection</h4>
						<br />
						<TimeBlock times={vendor.collectionTimes} />
					</div>
				</>
			}
			{Boolean(
				vendor.acceptDelivery &&
				vendor.deliveryTimes &&
				vendor.deliveryTimes.length
			) && <>
					<hr />
					<div className="padded">
						<h4>Opening Hours - Delivery</h4>
						<br />
						<TimeBlock times={vendor.deliveryTimes} />
					</div>
				</>
			}
		</div>
	</div>
}